import React from 'react';
import CancelAction from './Actions/CancelAction';
import RescheduledAction from './Actions/RescheduleAction';

import { Can } from '../../../../_contexts/AbilitiesContext'

export default function ScheduledActions({ telehealth }) {
  return <div>
    <Can I="reschedule" a="telehealth">
      <RescheduledAction telehealth={telehealth} />
      &nbsp;
    </Can>

    <Can I="cancel" a="telehealth">
      <CancelAction telehealth={telehealth} />
    </Can>
  </div>
}